import { Caries } from "./caries";
import { Fracture } from "./fracture";
import { SeverelyDamaged } from "./severely-damaged";
import { Wear } from "./wear";

export const conditions = [Caries, Fracture, SeverelyDamaged, Wear];



// WEBPACK FOOTER //
// /app/src/app/core/store/plan-editor/diagnosis/conditions/caries/index.ts